import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";

import { ProductCard } from "../components/ProductCard";
import { ErrorPanel, Loading } from "../components/States";
import { useStorefront } from "../components/SiteShell";
import { storeQueries } from "../lib/api";

export function ShopPage() {
  const { categorySlug } = useParams();
  const store = useStorefront();
  const products = useQuery({ queryKey: ["products", categorySlug ?? "all"], queryFn: () => storeQueries.products(categorySlug) });
  if (store.isLoading || products.isLoading) return <Loading label="Gathering the collection…" />;
  if (store.error || products.error || !store.data) return <ErrorPanel />;
  const category = store.data.categories.find((item) => item.slug === categorySlug);
  return (
    <section className="catalog-page section">
      <div className="catalog-header"><p className="eyebrow">Made one at a time</p><h1>{category?.name ?? "Shop everything"}</h1><p>{category?.description ?? "Playful pieces, thoughtful details, and a little bit of happy in every stitch."}</p></div>
      <nav className="category-pills" aria-label="Product categories"><Link className={!categorySlug ? "active" : ""} to="/shop">All</Link>{store.data.categories.map((item) => <Link className={item.slug === categorySlug ? "active" : ""} key={item.id} to={`/shop/${item.slug}`}>{item.name}</Link>)}</nav>
      {products.data?.length ? <div className="product-grid">{products.data.map((product) => <ProductCard key={product.id} product={product} />)}</div> : <div className="catalog-empty"><h2>Nothing on this rack just yet.</h2><p>Anne is making and photographing every piece herself. Check back soon or explore another category.</p><Link className="button primary" to="/shop">See all pieces</Link></div>}
    </section>
  );
}

